//#Global Imports
/* eslint-disable */
import React, { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
//#end Global Imports

//#Local Imports
import { TransferPhasebar } from "../../index";
import { debounce, getActiveStepNumber, transferPhaseData } from "../../../utils";
import { CloseIcon } from "../../../assets/Icons";
import Modal from "../../ui/Modal";
import Typograpy from "../../ui/Typography";
import Button from "../../ui/Button";
import useTimer from "../../../hooks/UseTimer";
import { useRecoilState } from "recoil";
import { showTimerText, transactionDetails, triggerTransactionSummary } from "../../../store";
import InfoIcon from "../../../assets/svg/info.svg";
import { getTransactionSummary } from "../../../services/remittance";
//#end Local Imports

// these routes basically follow the send money flow routes
const sendMoneyRoute = ["remittance", "remitter", "user-documents", "user-details", "recipient-details", "pick-recipient", "purpose-code", "review", "payment", "confirmation"]
const customRoute = ["remitter", "user-documents", "user-details", "recipient-details", "pick-recipient", "purpose-code", "review"]

export const TransferPhaseLayout = () => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const oldRate = localStorage.getItem("newRate") || "";
  const [newRates, setNewRates] = useState<string>('');
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = useLocation()
  const [activeStepNumber, setActiveStepNumber] = useState<number>(1);
  const [showWarning, setShowWarning] = useState<boolean>(false);
  // const { formattedTime, start, stop, reset,timeLeft } = useTimer(1800000);\
  // const timer = Number(process.env.REACT_APP_PAYMENT_FLOW_TIMER) || 1800000;
  const { formattedTime, start, stop, reset, timeLeft } = useTimer(1800000);
  const routeSegment = pathname.replace("/", "");
  const [apiCall, setAPICall] = useRecoilState(triggerTransactionSummary);
  const [showModal, setShowModal] = useState(false);
  const [showTimerModal, setShowTimerModal] = useRecoilState(showTimerText);
  const [transactionData, setTransactionData] = useRecoilState(transactionDetails);

  const idToken = localStorage.getItem("userToken") || "";

  // useEffect(() => {
  //   if (sendMoneyRoute.includes(routeSegment)) {
  //     if (["remittance", "payment"].includes(routeSegment)) {
  //       stop();
  //       reset();
  //       setShowTimerModal(false);
  //     } else if (routeSegment === "remitter") {
  //       start();
  //     }
  //   }
  // }, [pathname, reset, start, stop]);

  // const sendTranferSummary = () => {
  //   let body = transactionData;
  //   getTransactionSummary(
  //     {
  //       ...body,
  //       vendor_key: currentUser.vendor_key,
  //       bookRate: false,
  //     },
  //     idToken,
  //   )
  //     .then((response) => {
  //       localStorage.setItem("newRate", response?.data?.conversion_rate);
  //       setNewRates(response?.data?.conversion_rate.toString());
  //       setTransactionData({
  //         ...response?.data,
  //       })
  //     })
  //     .catch((err) => {
  //       console.error("Error in getting transaction summary", err);
  //     });
  // }

  // const debouncedSendTransferSummary = useCallback(
  //   debounce(() => {
  //     sendTranferSummary();
  //   }, 300),
  //   [sendTranferSummary],
  // );

  // useEffect(() => {
  //   if (timeLeft <= 0) {
  //     setAPICall(!apiCall);
  //     setShowModal(true);
  //     debouncedSendTransferSummary();
  //   }
  // }, [timeLeft])

  function handleCancelTransaction() {
    navigate("/home");
  }

  React.useEffect(() => {
    setActiveStepNumber(getActiveStepNumber(location.pathname, activeStepNumber));
  }, [location.pathname]);

  const showTimer = customRoute.includes(routeSegment)
  const handleContinue = () => {
    setShowModal(false);
    setShowTimerModal(false);
  }

  const rateCompare = oldRate === newRates;

  // console.log("showTimer&&!rateCompare&&showTimerModal", showTimer && !rateCompare && showTimerModal)
  // console.log("showTimer", showTimer)
  // console.log("rateCompare", rateCompare)
  // console.log("showTimerModal", showTimerModal)

  const customButton = (key: string) => {
    const commonCss = "w-full py-3 font-ssp font-semibold text-base rounded-lg";
    if (key === "continue") {
      return <button onClick={() => handleContinue()} className={`${commonCss} bg-[#023496] text-white font-semibold text-base`}>Continue</button>
    } else if (key === "new") {
      return <button onClick={() => navigate('/remittance')} className={`${commonCss} border border-[#565656] text-base text-[#565656]`}>Start New</button>
    }
    else null
  }

  // const showTimeoutModal = timeLeft <= 0 && !rateCompare && showModal;
  // console.log("showTimeoutModal",showTimeoutModal)
  // const showTimerTextThing:any = showTimer && showTimerModal;
  // console.log("showTimerText",showTimerText)

  return (
    <div className="flex">
      <TransferPhasebar data={transferPhaseData} activeStepNumber={activeStepNumber} />
      <div className="ml-[379px] w-full h-full relative">
        {/* {
          showTimeoutModal &&
          <div className="absolute top-0 left-0 w-full h-full z-20 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-4 rounded-lg w-fit">
              <div className="flex items-center justify-between w-full">
                <div className="w-8 h-8 rounded-full bg-[#FEEED7] animate-ping flex items-center justify-center">
                  <img src={InfoIcon} />
                </div>

                <p className="font-semibold text-base w-full text-left pl-2">Time Out</p>
              </div>
              <div className="flex flex-col px-6 items-start h-full w-full justify-center ml-2">
                <p className="font-normal text-base text-wrap w-80">Rates are refreshed. The new rate will be from Rs <span className="font-bold">{oldRate}</span> to Rs <span>{newRates}</span>.</p>
                <div className="flex items-center justify-center w-full gap-3 ">
                  {
                    ["continue", "new"].map((key: string, index: number) => {
                      return (
                        <div key={index} className="flex items-center justify-center w-full mt-4">
                          {customButton(key)}
                        </div>
                      )
                    }
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        } */}
        <div onClick={() => setShowWarning(true)} className="absolute z-10 ml-[5%] flex justify-between w-full items-center right-[6%] top-[5%]">
          {/* {
            showTimerTextThing &&
            <div className="w-fit ml-[35%] h-full "><p>Rates are locked for <span className="font-bold">30 minutes</span>. Please create the transaction within <span className="w-10 min-w-8 font-bold">{formattedTime}</span></p></div>
          } */}
          <CloseIcon />
        </div>
        <Outlet />
      </div>
      <Modal visible={showWarning} closeHandler={() => setShowWarning(false)} closable={false}>
        <Typograpy tagType="div" className="text-base font-semibold text-center text-black">
          <span className="text-[18px] text-red-100">
            Are you sure you wish to cancel the transaction ?
          </span>
        </Typograpy>
        <div className="flex items-center justify-center gap-10 p-8 pb-0">
          <Button
            bgColor="bg-secondary-600"
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-base",
              fontWeight: "font-semibold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className="p-2 px-10 confirmButtonRemitter"
            onClickHandler={handleCancelTransaction}
          >
            Yes
          </Button>
          <Button
            bgColor="bg-secondary-600"
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-base",
              fontWeight: "font-semibold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className="p-2 px-10 confirmButtonRemitter"
            onClickHandler={() => setShowWarning(false)}
          >
            No
          </Button>
        </div>
      </Modal>
    </div>
  );
};
